var t = /* @__PURE__ */ ((r) => (r.JSON = "json", r.JAVASCRIPT = "javascript", r.HTML = "html", r.CSS = "css", r))(t || {}), s = /* @__PURE__ */ ((r) => (r.Focus = "focus", r.Blur = "blur", r.Input = "input", r.Paste = "paste", r))(s || {});
export {
  s as EventType,
  t as Languages
};
